<template>
  <div class="ald-threejs-container">
    <slot></slot>
  </div>
</template>

<script>
  export default {};
</script>